// npm run watch:js

import { initializeBarba } from "./barba/barba";
import { initApplicationListSliders } from "./blocks/application-list.js";
import { initGalleryLightbox } from "./blocks/gallery-lightbox.js";
import { initCaseStudyShuffle } from "./shufflejs.js";
import { initCaseStudySliders } from "./blocks/case-study-slider.js";

document.addEventListener("DOMContentLoaded", () => {
  // Initialize Barba.js
  // initializeBarba();

  // Initialize application list sliders
  initApplicationListSliders(document);

  // Initialize gallery lightbox
  initGalleryLightbox(document);

  // Initialize ShuffleJS filtering on case studies
  initCaseStudyShuffle(document);

  // Initialize case study sliders
  initCaseStudySliders(document);

  // Prevent Barba.js from loading the WordPress admin bar
  document
    .querySelectorAll("#wpadminbar a")
    .forEach((item) => item.setAttribute("data-barba-prevent", "self"));
});
